export const TransactionHistoryMapper = (resp, pageSize) => {
    if (resp) {
        return {
            numberOfPages: pageSize > 0 ? Math.ceil(resp.transactionList.length / pageSize) : 0,
            pageSize: pageSize,
            totalRecords: resp.totalRecords,
            transactionList: resp.transactionList.map((x, idx) => {
                var _a;
                return {
                    accountCode: x.accountCode,
                    security: x.security,
                    transactionDate: x.transactionDate,
                    txnType: x.txnType,
                    action: x.action,
                    exchangeName: x.exchangeName,
                    quantity: x.quantity,
                    transactionPrice: x.transactionPrice,
                    brokerage: x.brokerage,
                    stampDutyCharges: x.stampDutyCharges,
                    sebiTax: x.sebiTax,
                    transactionCharge: x.transactionCharge,
                    other: x.other,
                    accountID: x.accountID,
                    tranId: x.tranId,
                    editFlag: x.editFlag,
                    filterFlags: Object.assign({}, x.filterFlags),
                    priceEditable: x.priceEditable,
                    splitAllowed: x.splitAllowed,
                    scripIdentifier: x.scripIdentifier,
                    cumulativeQuantity: x.cumulativeQuantity,
                    netCharges: x.netCharges,
                    edelweissProductShortCode: x.edelweissProductShortCode,
                    edelweissTabShortCode: x.edelweissTabShortCode,
                    stax_GST: x.stax_GST,
                    tstax: x.tstax,
                    stt: x.stt,
                    isin: x.isin,
                    editable: x.filterFlags.editable,
                    txnFlag: x.txnFlag,
                    netValue: !isNaN(Number(x.netValue)) ? Number(x.netValue) : 0,
                    brokerageCharges: x.netCharges,
                    rowNumber: idx,
                    quote: x.quote,
                    searchValue: (x === null || x === void 0 ? void 0 : x.transactionPrice.toString()) + (x === null || x === void 0 ? void 0 : x.netValue.toString()) + x.netCharges.toString() + x.security + x.transactionDate + x.action + x.isin + x.quantity + x.txnType + x.edelweissProductShortCode + x.edelweissTabShortCode + x.txnFlag + x.exchangeName + ((_a = x === null || x === void 0 ? void 0 : x.quote) === null || _a === void 0 ? void 0 : _a.displayName)
                };
            }),
        };
    }
    return {
        totalRecords: 0,
        numberOfPages: 0,
        pageSize: 0,
        transactionList: [],
    };
};
